module.exports = __webpack_public_path__ + "img/user-white.ae6068bb.svg";